import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from "../firebase/firebaseConfig";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";

const Groups = () => {
    const [data, setData] = useState([]);
    
    useEffect(() => {
        const fetchFormsData = async () => {
            try {
            const querySnapshot = await getDocs(collection(db, "Groups"));
            const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setData(documents);
            } catch (error) {
            console.error("Error fetching data: ", error);
            }
        };
    
        fetchFormsData();
    }, []);
    
  return (
    <div id="content">
        <div className='row'>
        <div className='col-sm-6'>
            <h1>Revival Church Groups</h1>
            <h2 className='ev-sub-title'>Montana Campus</h2>
        </div>
        <div className='col-sm-6 calendar-buttons'>
            <div className='event-button'>
                <Link to="/create-a-group"><button>Create a Group</button></Link>
            </div>
        </div>
        </div>
      <br/>
        <div className="row">
          {data.map((item, index) => (
            <div className="col-sm-3 forms-box" key={index}>
                <img src={item.FeaturedImage} className='group-image'/>
                <h3 className="forms-title">{item.Title}</h3>
                <p className="forms-meta-data">{item.Members} Members</p>
                <Link to={`/edit-group/${item.id}`}>Edit Group</Link>
            </div>
          ))}
        </div>
    </div>
  );
}

export default Groups;
